/**
 * Get Product Image Utility
 * 
 * Normalizes product image extraction from various field structures
 * used across the product catalog.
 */

/**
 * Extract product thumbnail URL from various possible field structures.
 * Products may have images stored as:
 * - image: string URL
 * - image: { src: string }
 * - primaryImg: string URL (used by product detail page)
 * - primaryImage: string URL
 * - files: { src: string }[] array (used by product detail page)
 * - images: string[] array
 * - images: { src: string }[] array
 *
 * @param {Object} product - Product data object
 * @returns {string|null} Image URL or null if not found
 */
export function getProductImage(product) {
    if (!product) return null;

    // Try direct image field (most common)
    if (product.image) {
        return typeof product.image === 'string' ? product.image : product.image?.src || null;
    }

    // Try primaryImg field (used by product detail page - note lowercase 'g')
    if (product.primaryImg) {
        return product.primaryImg;
    }

    // Try primaryImage field (used by Amazon ASIN discovery)
    if (product.primaryImage) {
        return product.primaryImage;
    }

    // Try files array (used by product detail page)
    if (product.files?.length > 0) {
        const first = product.files[0];
        return typeof first === 'string' ? first : first?.src || null;
    }

    // Try images array
    if (product.images?.length > 0) {
        const first = product.images[0];
        return typeof first === 'string' ? first : first?.src || null;
    }

    // Try thumbnail field (used by some API responses)
    if (product.thumbnail) {
        return product.thumbnail;
    }

    return null;
}

export default getProductImage;
